import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { BUCKET_URL } from './api-consts';

const params: AxiosRequestConfig = {
  baseURL: BUCKET_URL,
  timeout: 20000, // default timeout for all api requests
};
const bucketApiInstance = axios.create(params);

const useBucketApi = (): { bucketApiInstance: AxiosInstance } => {
  // NOTE: axios instance creation and interceptors need to be defined outside the scope of the hook
  // otherwise, the interceptor will fire nearly constantly and hinder app performance
  return {
    bucketApiInstance,
  };
};

export default useBucketApi;
